import { SemanticCOLORS, SemanticICONS } from 'semantic-ui-react';
import { tl } from 'common/services/i18nService';
import { ExplanationObject } from '../assessment/reducer';
import { ModalAction, ModalTypeKeys } from './actions';

export type ModalProperties = {
    hitData?: any;
    featureId?: string;
    name?: string;
    title?: string;
    cancelButtonColor?: SemanticCOLORS;
    cancelButtonCaptionKey?: string;
    confirmButtonColor?: SemanticCOLORS;
    confirmButtonCaptionKey?: string;
    icon?: SemanticICONS;
    whithoutIcon?: boolean;
    explanationSettings?: ExplanationObject;
    contentCaptionKey?: string;
    disallowCancel?: boolean;
    explanationRecordingDefaultFilename?: string;
};

export type ModalState = {
    showModal: boolean;
    properties?: ModalProperties;
};

export const initialState: ModalState = {
    showModal: false,
    properties: null,
};

export const modalReducer = (state = initialState, action: ModalAction) => {
    switch (action.type) {
    case ModalTypeKeys.CLOSE_MODAL: {
        return initialState;
    }
    case ModalTypeKeys.SHOW_MODAL: {
        return {
            showModal: true,
            properties: action.properties,
        };
    }
    case ModalTypeKeys.SHOW_CANCEL_EXPLANATION_OF_GRADES: {
        return {
            showModal: true,
            properties: {
                hitData: action.hitData,
                title: tl('grading.explanationOfGrades.cancelRequestNo'),
                name: 'cancelRequest',
            },
        };
    }
    case ModalTypeKeys.SHOW_REQUEST_EXPLANATION_OF_GRADES: {
        return {
            showModal: true,
            properties: {
                hitData: action.hitData,
                title: tl('grading.explanationOfGrades.showRequest'),
                name: 'request',
            },
        };
    }
    case ModalTypeKeys.SHOW_SEND_EXPLANATION_TO_CANDIDATE: {
        return {
            showModal: true,
            properties: {
                featureId: action.featureId,
                title: tl('grading.explanationOfGrades.sendExplanationToCandidate'),
                name: 'sendExplanationToCandidate',
            },
        };
    }
    case ModalTypeKeys.SHOW_SEND_EXPLANATION_TO_ALL_CANDIDATES: {
        return {
            showModal: true,
            properties: {
                featureId: action.featureId,
                title: tl('grading.explanationOfGrades.sendExplanationToAllCandidates'),
                name: 'sendExplanationToAllCandidates',
            },
        };
    }
    case ModalTypeKeys.SHOW_EDIT_EXPLANATION_DEADLINE: {
        return {
            showModal: true,
            properties: {
                title: tl('grading.explanationOfGrades.editDeadline'),
                cancelButtonColor: 'red',
                confirmButtonCaptionKey: 'grading.explanationOfGrades.editDeadlineUpdateButton',
                cancelButtonCaptionKey: 'grading.explanationOfGrades.cancelButtonText',
                name: 'editDeadline',
                whithoutIcon: true,
            },
        };
    }
    case ModalTypeKeys.SHOW_CONFIRM_CANCEL_RECORDING: {
        return {
            showModal: true,
            properties: {
                title: tl('grading.explanationRecording.cancelRecording.title'),
                cancelButtonColor: 'red',
                confirmButtonCaptionKey: 'grading.explanationRecording.cancelRecording.confirmButton',
                cancelButtonCaptionKey: 'grading.explanationRecording.cancelRecording.desistButton',
                name: 'confirmCancelExplanationRecording',
                whithoutIcon: true,
                contentCaptionKey: 'grading.explanationRecording.cancelRecording.content',
            },
        };
    }
    case ModalTypeKeys.SHOW_CONFIRM_REDO_RECORDING: {
        return {
            showModal: true,
            properties: {
                title: tl('grading.explanationRecording.redoRecording.title'),
                cancelButtonColor: 'grey',
                confirmButtonCaptionKey: 'grading.explanationRecording.redoRecording.confirmButton',
                cancelButtonCaptionKey: 'grading.explanationRecording.redoRecording.desistButton',
                name: 'confirmRedoExplanationRecording',
                whithoutIcon: true,
                contentCaptionKey: 'grading.explanationRecording.redoRecording.content',
            },
        };
    }
    case ModalTypeKeys.SHOW_SET_FILENAME_FOR_RECORDING: {
        return {
            showModal: true,
            properties: {
                title: tl('grading.explanationRecording.setFilename'),
                confirmButtonCaptionKey: 'explanationRecording.setFilename.saveButton',
                name: 'setFilenameForRecording',
                whithoutIcon: true,
                explanationRecordingDefaultFilename: action.defaultFilename,
                disallowCancel: true,
            },
        };
    }
    default:
        return state;
    }
};
